import { ThemeColors } from '@lyrahealth-inc/shared-app-logic'

import { getButtonStyles } from './buttonStyles'

export const getAuroraButtonStyles = (tokenColors: ThemeColors) => {
  const defaultButtonStyles = getButtonStyles(tokenColors)

  return {
    ...defaultButtonStyles,
    wordCloud: {
      ...defaultButtonStyles.wordCloud,
      default: {
        ...defaultButtonStyles.wordCloud.default,
        base: {
          ...defaultButtonStyles.wordCloud.default.base,
          borderRadius: 60,
          borderWidth: 1,
          borderColor: tokenColors.wordCloudButtonOutlineDefault,
          backgroundColor: tokenColors.wordCloudButtonBackgroundDefault,
          backdropFilter: 'blur(4px)',
        },
      },
    },
  }
}
